import { useTranslate } from "@refinedev/core";

export const useBusinessTypeOptions = () => {
  const translate = useTranslate();

  const getBusinessTypeOptions = () => [
    { value: "", label: translate("options.none") },
    { value: "club", label: translate("options.business_types.club") },
    { value: "bookstore", label: translate("options.business_types.bookstore") }
  ];

  return { getBusinessTypeOptions };
};
